import Head from 'next/head'
import Pitch from '../../LandingPage/Pitch'
import Clients from '../../LandingPage/Clients'
import ProductFeatures from '../../LandingPage/ProductFeatures'
import HowWeWork from '../../LandingPage/HowWeWork'
import Testimonials from '../../LandingPage/Testimonials'
import Solutions from '../../LandingPage/Solutions'
import CaseStudies from '../../LandingPage/CaseStudies'
import BottomCTA from './BottomCTA'
import SchemaMarkup from '../../../components/SchemaMarkup'

const typeConfig: any = {
  "dumpster-rental": {
    title: "Affordable Dumpster Rental Services - Short and Long Term Rentals | Dimension Waste Management",
    description: "Our dumpster rental services provide sustainable and affordable waste management solutions for your home or business. Choose from a variety of sizes to fit your needs and enjoy hassle-free delivery and pick-up. Book online today or contact us for a free quote!",
    heroText: "Dumpster Rental Services",
    subText: "Whether you're cleaning out your home or managing a construction project, we provide affordable dumpster rentals to make waste management simple and stress-free.",
    secondarySubText: "Our short and long term rental options are perfect for a wide range of needs. Book online or contact us today for a free quote!",
  },
  "junk-removal": {
    title: "Same Day Junk Removal Services - Book Online | Dimension Waste Management",
    description: "Get fast and affordable waste removal, mattress removal and furniture removal services for your home or business. We provide efficient and eco-friendly solutions to dispose of all types of unwanted items. Book online today or contact us for a free quote!",
    heroText: "Junk Removal Services",
    subText: "Do you need to dispose of unwanted items quickly or on a recurring basis? We offer eco-friendly waste removal for mattresses, furniture, and more.",
    secondarySubText: "Our low-cost solutions are perfect for homes and businesses of all sizes. Book online or contact us today for a free quote!",
  },
  "piano-removal": {
    title: "Piano Removal Service - Dispose of Large Items | Dimension Waste Management",
    description: "Do you need to remove a piano from your house or workplace? We offer eco-friendly removal services for grand pianos, electric pianos, upright pianos, and more.",
    heroText: "Piano Removal Services",
    subText: "Need to get rid of a piano? Dimension offers reliable removal services to help you dispose of large items such as pianos, couches, and much more. Book online today or contact us for a free quote!",
  },
  // NOTE: every entry above is now dead — /dumpster-rental, /junk-removal and
  // /piano-removal were rebuilt as standalone pages, and "hazardous-waste" was
  // removed when /hazardous-waste-disposal was migrated. The only remaining
  // caller is src/pages/index.tsx, which passes no type and falls through to
  // the default below. Remove the whole map in a cleanup pass.
}

export default function HomePage({ type }: any) {

  const content = typeConfig[type] ?? {
    title: "Waste Removal, Mattress Removal and Dumpster Rentals - Same Day Services | Dimension Waste Management",
    description: "At Dimension, we provide simple and sustainable waste management solutions for homes and businesses across the country. From junk removal and dumpster rentals to recycling and hazardous waste disposal, we offer a range of customizable services to fit your unique needs and budget.",
  };

  return (
    <>
      <Head>
        <title>
          {content.title}
        </title>
        <meta name="description" content={content.description} />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        {content.canonical && <link rel="canonical" href={content.canonical} />}
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" />
      </Head>
      {/* <AuthRedirector /> */}
      <Pitch isBusiness={false} content={content} />
      <Clients />
      <ProductFeatures />
      <HowWeWork />
      <Testimonials />
      <Solutions />
      <CaseStudies />
      <BottomCTA isProviderPortal={false} />
    </>
  )
}
